export const LEGAL_CONSENT_STORAGE_KEY = 'sputnik_legal_consent';

export const LEGAL_CONSENT_STEPS = [
  {
    id: 'cookies',
    description:
      'Нажав кнопку «Принимаю», Вы соглашаетесь на обработку обязательных ' +
      '<a href="/docs/Что_такое_cookie.pdf" target="_blank" rel="noopener noreferrer">cookie</a>. ' +
      'Запретить обработку файлов cookie Вы можете в настройках своего браузера.',
  },
  {
    id: 'privacy',
    description:
      'Нажав кнопку «Принимаю», Вы соглашаетесь с ' +
      '<a href="/docs/Политика_обработки_персональных_данных.pdf" target="_blank" rel="noopener noreferrer">' +
      'Политикой обработки персональных данных</a>.',
  },
  {
    id: 'terms',
    description:
      'Нажав кнопку «Принимаю», Вы подтверждаете ознакомление с ' +
      '<a href="/docs/Пользовательское_соглашение_2026.pdf" target="_blank" rel="noopener noreferrer">' +
      'Пользовательским соглашением</a>.',
  },
];

export function loadAcceptedCategories() {
  try {
    const raw = localStorage.getItem(LEGAL_CONSENT_STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const data = JSON.parse(raw);
    return Array.isArray(data.categories) ? data.categories : [];
  } catch {
    return [];
  }
}

export function saveAcceptedCategories(categories) {
  localStorage.setItem(
    LEGAL_CONSENT_STORAGE_KEY,
    JSON.stringify({
      categories,
      consentTimestamp: new Date().toISOString(),
    }),
  );
}
